/* istanbul ignore file */
import find from 'lodash/find';
import isNaN from 'lodash/isNaN';
import {isAsciiEmail} from 'sane-email-validation';

const constraints = [
  {
    name: 'min',
    pattern: 'numeric',
    // @ts-ignore
    check(value, constraintValue) {
      return +value >= constraintValue;
    },
    // @ts-ignore
    message(_name, constraintValue) {
      return {
        term: 'CommonFormatting.NumericValidationMin',
        params: {numbermin: constraintValue},
      };
    },
  },
  {
    name: 'max',
    pattern: 'numeric',
    // @ts-ignore
    check(value, constraintValue) {
      return +value <= constraintValue;
    },
    // @ts-ignore
    message(_name, constraintValue) {
      return {
        term: 'CommonFormatting.NumericValidationMax',
        params: {numbermax: constraintValue},
      };
    },
  },
  {
    name: 'minLength',
    // @ts-ignore
    check(value, constraintValue) {
      return value.length >= constraintValue;
    },
    // @ts-ignore
    message(_name, constraintValue) {
      return {
        term: 'CommonFormatting.NumericValidationMin',
        params: {numbermin: constraintValue - 1},
      };
    },
  },
  {
    name: 'maxLength',
    // @ts-ignore
    check(value, constraintValue) {
      return value.length <= constraintValue;
    },
    // @ts-ignore
    message(_name, constraintValue) {
      return {
        term: 'CommonFormatting.CharactersValidationMax',
        params: {numbermax: constraintValue},
      };
    },
  },
];

const constraintKeys = constraints.map(def => def.name);

const patterns = [
  {
    name: 'email',
    // @ts-ignore
    check(value) {
      return isAsciiEmail(value);
    },
    message() {
      return {term: 'NextPeople.EmailError_EmailNotValid'};
    },
  },
  {
    name: 'numeric',
    // @ts-ignore
    check(value) {
      return !isNaN(+value);
    },
    message() {
      return {term: 'CommonFormatting.NumericFormat'};
    },
  },
  {
    name: 'containsNonWhitespace',
    // @ts-ignore
    check(value) {
      const patt = new RegExp(/\S+/);
      return patt.test(value);
    },
    message() {
      return {term: 'CommonFormatting.MustContainNonWhitespace'};
    },
  },
  {
    name: 'password',
    // @ts-ignore
    check(value) {
      const patt = new RegExp('.{8,}$');
      return patt.test(value);
    },
    message() {
      return {
        term: 'SignUp.PasswordNotValid_Error',
        fallback:
          'Invalid password. Please enter a new password with a minimum of 8 characters.',
      };
    },
  },
];
// @ts-ignore
function isEmpty(value) {
  // Hopefully only relations can be arrays
  if (Array.isArray(value)) {
    return !value.length;
  }
  return value === null || typeof value === 'undefined' || value === '';
}

// @ts-ignore
function checkRequired(_name, value) {
  if (isEmpty(value)) {
    return {
      term: 'CommonTerms.Generic_RequiredField',
      fallback: 'Required field',
    };
  }
}

// @ts-ignore
function checkPattern(name, value, patternName) {
  const pattern = find(patterns, {name: patternName});

  if (pattern) {
    if (!isEmpty(value)) {
      if (!pattern.check(value)) {
        // @ts-ignore
        return pattern.message(name);
      }
    }
  } else {
    throw Error(`"${patternName}" pattern is not defined!`);
  }
}
// @ts-ignore
function checkConstraint(name, value, constraintName, constraintValue) {
  if (constraintValue !== undefined && constraintValue !== null) {
    const constraint = find(constraints, {name: constraintName});

    if (constraint) {
      let pattern;

      if (constraint.pattern) {
        pattern = find(patterns, {name: constraint.pattern});
      }

      if (!pattern || pattern.check(value)) {
        if (!isEmpty(value)) {
          if (!constraint.check(value, constraintValue)) {
            return constraint.message(name, constraintValue);
          }
        }
      }
    } else {
      throw Error(`"${constraintName}" constraint is not defined!`);
    }
  }
}
// @ts-ignore
function checkCustom(model, value, firstPassErrors, check, message) {
  if (!check(model, value, firstPassErrors)) {
    return message;
  }
}

export default {
  /**
   * @params {bool} options.ignoreRequired
   */
  // @ts-ignore
  validate(attrs, rules, options = {}) {
    const firstPassErrors = {};

    Object.keys(rules).forEach(key => {
      const rule = rules[key];
      const value = attrs[key];
      let error;
      // Required
      // @ts-ignore
      if (rule.required && !options.ignoreRequired) {
        error = checkRequired(key, value);
      }

      if (typeof value !== 'undefined') {
        // Patterns
        if (!isEmpty(value) && rule.pattern) {
          error = checkPattern(key, value, rule.pattern);
        }

        // Constraints
        if (!error) {
          Object.keys(rule).some(rkey => {
            if (constraintKeys.includes(rkey)) {
              const constraintValue = rule[rkey];
              error = checkConstraint(key, value, rkey, constraintValue);
              return error;
            }
          });
        }
      }

      if (error) {
        // @ts-ignore
        firstPassErrors[key] = error;
      }
    });

    // Second pass - performs any custom validation
    const secondPassErrors = {};
    Object.keys(rules).forEach(key => {
      const rule = rules[key];
      const value = attrs[key];
      let error;

      if (!isEmpty(value)) {
        if (rule.check && rule.message) {
          // the rule itself is a custom rule
          error = checkCustom(
            attrs,
            value,
            firstPassErrors,
            rule.check,
            rule.message
          );
        } else if (rule.custom) {
          // there is a nested custom rule
          error = checkCustom(
            attrs,
            value,
            firstPassErrors,
            rule.custom.check,
            rule.custom.message
          );
        }
      }

      if (error) {
        // @ts-ignore
        secondPassErrors[key] = error;
      }
    });

    const combinedErrors = {
      ...firstPassErrors,
      ...secondPassErrors,
    };

    if (Object.keys(combinedErrors).length) {
      return combinedErrors;
    } else {
      return null;
    }
  },
};
